var map = {
	"./2009-10pdf-469db2a01b72e28779ecf291669ae95e.pdf": 40912,
	"./2010-11pdf-3513fb854c6cf6aa8cf71357b0d3dc70.pdf": 5489,
	"./2010-2011pdf-eb294fed405830fb0c0b6b041a48c00c.pdf": 41843,
	"./2011-2012pdf-2546b9562f5768ff53a6252f837c8cda.pdf": 43947,
	"./2012-13pdf-20bf67b950dd7927205837023ce2ca6e.pdf": 51426,
	"./2013-14pdf-b11349448b5d1814cf05bec9f2a5d8bf (1).pdf": 3511,
	"./2013-14pdf-b11349448b5d1814cf05bec9f2a5d8bf.pdf": 88849,
	"./2014-15-pdf-eaa4227b5bdd82c83ec46f9d9a768314.pdf": 77935,
	"./R--2020-21pdf-6ee7209476980dbfdc60077dd4905bef.pdf": 63013,
	"./R-2015-16-pdf-a79a73bfe582d6902525b06529576de9.pdf": 21624,
	"./R-2016-17pdf-5c6c1038218db3465b1794d383fe65ae.pdf": 8815,
	"./R-2017-18pdf-a18d21548d03a749f29c24af32adb69d.pdf": 41860,
	"./R-2018-19PDF-f626d3f55ec961a0eb245539ca60d2be.pdf": 73804,
	"./R-2019-20-up-to-JulyPDF-14de216d552f624791cb30e64a20af4a.pdf": 96372,
	"./R-2019-20-up-to-Macrh-20PDF-1c3d51c82a7fdab3a1eb902b626e5cf1.pdf": 3794,
	"./RAJAYA-SABH_2021_2022A60be6pdf-336e2c9ecbf0294ca0cefa82a19d014b.pdf": 73894,
	"./RS_2024_2025Qcompressedpdf-192f08856e3134c4e5bd954c4369bcfb.pdf": 6341,
	"./Rajya-Sabha-2022-23PDF-58965847039d3550649ce0568ece528a.pdf": 56185,
	"./Rajya-Sabha_2023_2024PDF-dd26fa0d2dc1b8c73e174222b2294576.pdf": 98725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35986;